module.exports = __webpack_public_path__ + "img/favicon_havsutsikt.3786aa29.svg";